import './style.scss';
import Flickity from 'flickity';
import 'flickity/dist/flickity.min.css';
import { useEffect, useRef } from '@wordpress/element';
import { useSelect } from '@wordpress/data';
import { InspectorControls, useBlockProps } from '@wordpress/block-editor';
import { PanelBody, ToggleControl } from '@wordpress/components';
import { __ } from '@wordpress/i18n';
import metadata from './block.json';

const { registerBlockType } = wp.blocks;


registerBlockType(metadata.name, {
    title: __('FlexiFlick Slider', 'flexiflick'),
    icon: 'slides',
    category: 'widgets',
    attributes: {
        showArrows: {
            type: 'boolean',
            default: true,
        },
        showPager: {
            type: 'boolean',
            default: true,
        },
    },
edit({ attributes, setAttributes }) {
    const blockProps = useBlockProps();
    const sliderRef = useRef();

    // Fetch the custom post type content
    const posts = useSelect((select) => {
        const fetchedPosts = select('core').getEntityRecords('postType', 'flexiflick_slide_cpt', {
            per_page: 3, // Limit the number of posts for the preview
            _embed: true, // Embed related resources, such as the featured media
        });

        if (fetchedPosts) {
            return fetchedPosts.map((post) => ({
                id: post.id,
                title: post.title.rendered,
                content: post.content.rendered, // Use the body content instead of the excerpt
                featured_media_url: post._embedded?.['wp:featuredmedia']?.[0]?.source_url || '',
            }));
        }

        return [];
    }, []);

    useEffect(() => {
            // Initialize Flickity only if posts are loaded
            if (posts.length > 0 && sliderRef.current) {
                const flickityInstance = new Flickity(sliderRef.current, {
                    prevNextButtons: attributes.showArrows,
                    pageDots: attributes.showPager,
                });

                return () => {
                    flickityInstance.destroy();
                };
            }
        }, [attributes.showArrows, attributes.showPager, posts]);


    return (
        <div {...blockProps}>
                <InspectorControls>
                    <PanelBody title={__('Slider Settings', 'flexiflick')}>
                        <ToggleControl
                            label={__('Show Arrows', 'flexiflick')}
                            checked={attributes.showArrows}
                            onChange={(value) => setAttributes({ showArrows: value })}
                        />
                        <ToggleControl
                            label={__('Show Pager', 'flexiflick')}
                            checked={attributes.showPager}
                            onChange={(value) => setAttributes({ showPager: value })}
                        />
                    </PanelBody>
                </InspectorControls>
                <div className="flickity-placeholder">
                    <div  ref={sliderRef}>
                            <div className="flickity-placeholder-content">
                                <h3>Flickity Responsive Slider/Carousel</h3>
                                <p>....................................</p>
                                <p>{`{ showArrows: ${attributes.showArrows ? 'True' : 'False'} }`}</p>
                                <p>{`{ showPager: ${attributes.showPager ? 'True' : 'False'} }`}</p>
                            </div>
                    </div>
                </div>
            </div>
    );
    },
    save() {
        return null; // Rendered on the server.
    },
});
